"use client";

import { ReactNode } from "react";
import { useAuth } from "./auth-provider";
import type { Role } from "@/lib/auth";

interface RequireRoleProps {
  roles: Role[];
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * Conditionally render children only if current user's role is in `roles`.
 * platform_admin always passes.
 */
export function RequireRole({ roles, fallback = null, children }: RequireRoleProps) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.is_platform_admin) return <>{children}</>;
  if (!roles.includes(user.role)) return <>{fallback}</>;
  return <>{children}</>;
}
